import { Link } from 'react-router';
import { SITE_NAME, SITE_TAGLINE_CAPITALIZED } from '../../config/site';

/**
 * Todas rutas internas, aunque una todavía no exista (Prensa): mejor un «no
 * encontrado» propio que mandar a alguien al sitio Jekyll que estamos
 * dejando atrás.
 */
const footerLinks = [
  ['Acerca de', '/post/info/acerca-de'],
  ['Dirige una partida', '/dirige-una-partida'],
  ['Prensa', '/press'],
  ['Aviso legal', '/post/info/aviso-legal'],
  ['Política de privacidad', '/post/info/privacidad'],
] as const;

const socialLinks = [
  ['Instagram', 'https://www.instagram.com/rolsensorial/', 'bi-instagram'],
  ['TikTok', 'https://www.tiktok.com/@rol.sensorial', 'bi-tiktok'],
  ['YouTube', 'https://www.youtube.com/channel/UCLKgDybAY1rPEvDdwch-i2Q', 'bi-youtube'],
] as const;

export function SiteFooter() {
  return (
    <footer className="site-footer" aria-label="Pie de página">
      <div className="container py-4">
        <nav aria-label="Rol Sensorial">
          <ul className="rs-footer-links list-unstyled mb-0">
            {footerLinks.map(([label, href]) => (
              <li key={label}><Link to={href}>{label}</Link></li>
            ))}
          </ul>
        </nav>

        <details className="rs-footer-social mt-3">
          <summary>Síguenos</summary>
          <ul className="list-unstyled mt-2 mb-0">
            {socialLinks.map(([label, href, icon]) => (
              <li key={label}>
                {/* Que el enlace abra una pestaña nueva hay que avisarlo, pero
                    escribirlo al lado de cada red llena el pie de una frase
                    repetida. Va en el nombre accesible: el lector lo dice y
                    la pantalla solo muestra la red. */}
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${label} (se abre en una pestaña nueva)`}
                >
                  <i className={`bi ${icon}`} aria-hidden="true" />
                  <span>{label}</span>
                </a>
              </li>
            ))}
          </ul>
        </details>

        <p className="rs-footer-copyright mt-4 mb-0">
          © 2019–{new Date().getFullYear()} {SITE_NAME}. {SITE_TAGLINE_CAPITALIZED} Todos los derechos reservados.
        </p>
      </div>
    </footer>
  );
}
